document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('instrument-search');
  const grid = document.getElementById('instrument-grid');
  const emptyState = document.getElementById('instrument-empty');
  const familyButtons = Array.from(document.querySelectorAll('[data-family-filter]'));
  if (!input || !grid) return;

  const cards = Array.from(grid.querySelectorAll('.instrument-card'));
  let debounceTimer = null;

  function filter(query) {
    const q = query.trim().toLowerCase();
    let visibleCount = 0;

    cards.forEach((card) => {
      const matches = !q
        || card.dataset.name.includes(q)
        || card.dataset.family.includes(q);
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (emptyState) {
      emptyState.hidden = !(q && visibleCount === 0);
    }
  }

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const value = input.value;
    debounceTimer = setTimeout(() => filter(value), 100);
  });

  familyButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const family = btn.dataset.familyFilter || '';
      input.value = family;
      filter(family);
      familyButtons.forEach((b) => b.classList.toggle('is-active', b === btn));
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});